export default __webpack_public_path__ + "static/media/Dian Greef.1baf2afd.jpeg";